<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button icon="keyboard_backspace" @click="goBack">Back</vs-button>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="10"
          vs-sm="4"
          vs-xs="12"
        >
          <h3>
            {{ campaignDescription.campaign_name }} - Review Opportunity Changes
          </h3>
        </vs-col>
      </vs-row>

      <template v-for="(changes, index_number) in opportunity_review_changes">
        <template>
          <vs-row>
            <vs-col vs-type="flex" vs-w="3" class="pb-5 pt-10">
              <h6 class="mr-5">Company Name :</h6>
              <a
                class="hyperlink_class"
                @click="goToReviewDataChangesDetail(changes['account_id'])"
                >{{ changes['company_name'] }}</a
              >
            </vs-col>

            <vs-col vs-type="flex" vs-w="3" class="pb-5 pt-10">
              <h6 class="mr-5" v-if="changes['forename']">First Name :</h6>
              {{ changes['forename'] }}
            </vs-col>
            <vs-col vs-type="flex" vs-w="2" class="pb-5 pt-10">
              <h6 class="mr-5" v-if="changes['surname']">Surname :</h6>
              {{ changes['surname'] }}
            </vs-col>
            <vs-col vs-type="flex" vs-w="3" class="pb-5 pt-10">
              <h6 class="mr-5" v-if="changes['job_title']">Job Role :</h6>
              {{ changes['job_title'][0]['job_title'] }}
            </vs-col>
            <vs-col vs-type="flex" vs-w="1" class="pb-5 pt-10">
              <h6 class="mr-5" v-if="changes['job_title']">Status :</h6>
              {{ changes['opp_status'] }}
            </vs-col>
          </vs-row>
          <table class="table" style="width: 100%">
            <tbody>
              <tr>
                <td v-for="(ob, ind) in Object.keys(changes).slice(10, 15)">
                  <!-- {{ ob }}  -->

                  <template v-if="changes[ob] != null">
                  
                      <template
                        v-for="field_array_column in changes[
                          'campaign_data_options'
                        ]"
                      >
                        <template v-if="field_array_column.column_id == ob">
                          <strong>
                            <p class="p-5">{{ field_array_column.name }}</p>
                          </strong>
                        </template>
                      </template>

                      <template
                        v-for="field_array_column in changes[
                          'campaign_data_options'
                        ]"
                      >
                        <template v-if="field_array_column.column_id == ob">


                          <div
                            v-if="
                              field_array_column['type'] == 'client_contact'
                            "
                          >
                            <div class="width_class">
                              <div class="auto_search_container">
                                
                                

                                <input class="autocom" :id="'search_id_' + index_number" @input="intitudeHandler($event, index_number)" type="text"
                                  v-model="changes[ob]['full_name']" @blur="toggle = false" @focus="toggle = true"> {{
                                    changes[ob]['full_name'] }}
                                <div class="results" v-if="toggle">

                                  <div v-if="changes['opp_owner_search']" class="result"
                                    v-for="client_contact in newCampaignClientContacts">
                                    <span @click="selectResult(index_number, client_contact, ob)" @mousedown.prevent>
                                      {{ client_contact.full_name }}
                                    </span>
                                  </div>



                                </div>
                              </div>
                            </div>


                            <template
                              v-for="(value1, key1) in changes['old_one']"
                              
                            >

                              <template v-if="field_array_column['type'] == 'client_contact' && field_array_column['column_id'] == key1">
                                <div class="width_class">
                                  
                                  
                                  
                                  <template v-if="value1 != '' && value1 != null && changes[field_array_column['column_id']]['full_name'] != ''">
                                    <template v-if="changes[field_array_column['column_id']]['full_name'] !=  JSON.parse(value1)['full_name']">
                                      <vs-divider class="p-1" />




                                      {{ value1 != '' && value1 != null ? JSON.parse(value1)['full_name'] : 'EMPTY' }}
                                    </template>
                                    
                                  </template>
                
                                  <template v-else-if="changes[field_array_column['column_id']]['full_name'] !=  value1">
                                    <vs-divider class="p-1" />


                                    {{ value1 != '' && value1 != null ? value1 : 'EMPTY' }}


                                    <!-- {{ value1 != '' &&  JSON.parse(value1).full_name != '' ? value1 : 'EMPTY' }} -->
                
                
                                    </template>
                                </div>
                              </template>
                            </template>
                          </div>

                          <div v-else>
                            <div
                              v-if="field_array_column['type'] == 'checkbox'"
                              class="width_class"
                            >
                              <span
                                v-for="(v, key) in JSON.parse(
                                  field_array_column['values']
                                )"
                              >
                                <input
                                  type="checkbox"
                                  v-bind:id="key"
                                  class="ml-4"
                                  :value="v.value"
                                  v-model="changes[ob]"
                                />
                                {{ v.value }}
                                <br />
                              </span>
                            </div>
                            <div
                              v-if="field_array_column['type'] == 'dropdown'"
                            >
                              <v-select
                                class="width_class"
                                v-model="changes[ob]"
                                label="value"
                                :options="
                                  JSON.parse(field_array_column['values'])
                                "
                                name="type"
                              />
                            </div>

                            <div
                              v-if="
                                field_array_column['type'] == 'text' ||
                                field_array_column['type'] == 'opportunity'
                              "
                            >
                              <vs-input
                                class="width_class"
                                name="text"
                                v-model="changes[ob]"
                              />
                            </div>


                            <div
                            v-if="
                              field_array_column['type'] == 'number'
                            "
                          >
                            <vs-input
                            type="number" 
                            class="width_class"
                                name="text"
                              v-model="changes[ob]"
                            />
                          </div>



                            <div
                              v-if="field_array_column['type'] == 'textarea'"
                            >

                            <vue-trumbowyg v-model="changes[ob]" 
                            :config="configs.basic"></vue-trumbowyg>



                              <!-- <vs-textarea
                                class="ql-class"
                                v-model="changes[ob]"
                              /> -->
                            </div>
                            <div v-if="field_array_column['type'] == 'date'">
                              <flat-pickr
                                class="width_class"
                                :config="configDateTimePicker"
                                placeholder="Choose Date"
                                name="continuous_date_end"
                                v-model="changes[ob]"
                              />
                            </div>

                               <div v-if="field_array_column['type'] == 'datetime'">
                              <flat-pickr
                                class="width_class"
                                :config="configDateAndTimePicker"
                                placeholder="Choose Date and Time"
                                name="continuous_date_and_time"
                                v-model="changes[ob]"
                              />
                            </div>

                            <div
                              v-if="field_array_column['type'] == 'choose_one'"
                              class="width_class"
                            >
                              <span
                                v-for="(val, k) in JSON.parse(
                                  field_array_column['values']
                                )"
                              >
                                <input
                                  class="ml-4"
                                  :value="val.value"
                                  type="radio"
                                  v-model="changes[ob]"
                                />
                                {{ val.value }}
                                <br />
                              </span>
                            </div>

                            <template
                              v-for="(value1, key1) in changes['old_one']"
                            >
                              <template v-if="key1 == ob">
                                <div class="width_class">
                                  <template
                                    v-if="
                                      field_array_column['type'] ==
                                        'checkbox' && Array.isArray(value1) &&
                                      changes[ob].length != value1.length
                                    "
                                  >
                                    <vs-divider class="p-1" />
                                    {{ value1.length == 0 ? 'EMPTY' : value1 }}
                                  </template>
                                  <template
                                    v-if="
                                      field_array_column['type'] !=
                                        'checkbox' && changes[ob] != value1
                                    "
                                  >
                                    <vs-divider class="p-1" />
                                    {{
                                      value1 == null || value1 == ''
                                        ? 'EMPTY'
                                        : value1
                                    }}
                                  </template>
                                </div>
                              </template>
                            </template>
                          </div>
                        </template>
                      </template>

                  </template>
                </td>
                <strong>
                  <p class="p-5">Action</p>
                </strong>
                <feather-icon
                  @click="reviewerOpportunityAccepted(changes)"
                  icon="CheckIcon"
                  class="accept-button p-5"
                />
                <feather-icon
                  @click="reviewerOpportunityRejected(changes)"
                  class="accept-button p-5"
                  icon="DeleteIcon"
                />
              </tr>

              <tr>
                <td v-for="(ob, ind) in Object.keys(changes).slice(15, 20)">
                  <!-- {{ ob }}  -->

                  <template v-if="changes[ob] != null">
                   
                      <template
                        v-for="field_array_column in changes[
                          'campaign_data_options'
                        ]"
                      >
                        <template v-if="field_array_column.column_id == ob">
                          <strong>
                            <p class="p-5">{{ field_array_column.name }}</p>
                          </strong>
                        </template>
                      </template>

                      <template
                        v-for="field_array_column in changes[
                          'campaign_data_options'
                        ]"
                      >
                        <template v-if="field_array_column.column_id == ob">

                 

                          

                          <div
                            v-if="
                              field_array_column['type'] ==
                              'client_contact'
                            "
                          >
                            <div class="width_class">
                              <div class="auto_search_container">
                                <input
                                  class="autocom"
                                  :id="'search_id_' + index_number"
                                  @input="intitudeHandler($event, index_number)"
                                  type="text"
                                  v-model="changes[ob]['full_name']"
                                  @blur="toggle = false"
                                  @focus="toggle = true"
                                />
                                {{ changes[ob]['full_name'] }}
                                <div class="results" v-if="toggle">
                                  <div
                                    v-if="changes['opp_owner_search']"
                                    class="result"
                                    v-for="client_contact in newCampaignClientContacts"
                                  >
                                    <span
                                      @click="
                                        selectResult(index_number, client_contact, ob)
                                      "
                                      @mousedown.prevent
                                    >
                                      {{ client_contact.full_name }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <template
                              v-for="(value1, key1) in changes['old_one']"
                            >
                              <template v-if="key1 == 'client_contact'">
                                <div class="width_class">
                                  <template
                                    v-if="
                                      value1 != '' && value1 != null &&
                                      changes['client_contact'][
                                        'full_name'
                                      ] != ''
                                    "
                                  >
                                    <template
                                      v-if="
                                        changes['client_contact'][
                                          'full_name'
                                        ] != value1['full_name']
                                      "
                                    >
                                      <vs-divider class="p-1" />
                                      {{
                                        value1 != '' && value1 != null
                                          ? value1['full_name']
                                          : 'EMPTY'
                                      }}
                                    </template>
                                  </template>

                                  <template
                                    v-else-if="
                                      changes['client_contact'][
                                        'full_name'
                                      ] != value1
                                    "
                                  >
                                    <vs-divider class="p-1" />
                                    {{ value1 != '' && value1 != null ? value1 : 'EMPTY' }}
                                  </template>
                                </div>
                              </template>
                            </template>
                          </div>

                          <div v-else>
                            <div
                              v-if="field_array_column['type'] == 'checkbox'"
                              class="width_class"
                            >
                              <span
                                v-for="(v, key) in JSON.parse(
                                  field_array_column['values']
                                )"
                              >
                                <input
                                  type="checkbox"
                                  v-bind:id="key"
                                  class="ml-4"
                                  :value="v.value"
                                  v-model="changes[ob]"
                                />
                                {{ v.value }}
                                <br />
                              </span>
                            </div>
                            <div
                              v-if="field_array_column['type'] == 'dropdown'"
                            >
                              <v-select
                                class="width_class"
                                v-model="changes[ob]"
                                label="value"
                                :options="
                                  JSON.parse(field_array_column['values'])
                                "
                                name="type"
                              />
                            </div>

                            <div
                              v-if="
                                field_array_column['type'] == 'text' ||
                                field_array_column['type'] == 'opportunity'
                              "
                            >
                              <vs-input
                                class="width_class"
                                name="text"
                                v-model="changes[ob]"
                              />
                            </div>

                            <div
                            v-if="
                              field_array_column['type'] == 'number'
                            "
                          >
                            <vs-input
                            type="number" 
                            class="width_class"
                                name="text"
                              v-model="changes[ob]"
                            />
                          </div>

                            <div
                              v-if="field_array_column['type'] == 'textarea'"
                            >

                            <vue-trumbowyg v-model="changes[ob]" 
                            :config="configs.basic"></vue-trumbowyg>
                              <!-- <vs-textarea
                                class="ql-class"
                                v-model="changes[ob]"
                              /> -->
                            </div>
                            <div v-if="field_array_column['type'] == 'date'">
                              <flat-pickr
                                class="width_class"
                                :config="configDateTimePicker"
                                placeholder="Choose Date"
                                name="continuous_date_end"
                                v-model="changes[ob]"
                              />
                            </div>
                              <div v-if="field_array_column['type'] == 'datetime'">
                              <flat-pickr
                                class="width_class"
                                :config="configDateAndTimePicker"
                                placeholder="Choose Date and Time"
                                name="continuous_date_and_time"
                                v-model="changes[ob]"
                              />
                            </div>

                            <div
                              v-if="field_array_column['type'] == 'choose_one'"
                              class="width_class"
                            >
                              <span
                                v-for="(val, k) in JSON.parse(
                                  field_array_column['values']
                                )"
                              >
                                <input
                                  class="ml-4"
                                  :value="val.value"
                                  type="radio"
                                  v-model="changes[ob]"
                                />
                                {{ val.value }}
                                <br />
                              </span>
                            </div>
                            <template
                              v-for="(value1, key1) in changes['old_one']"
                            >
                              <template v-if="key1 == ob">
                                <div class="width_class">
                                  <template
                                    v-if="
                                      field_array_column['type'] ==
                                        'checkbox' && Array.isArray(value1) &&
                                      changes[ob].length != value1.length
                                    "
                                  >
                                    <vs-divider class="p-1" />
                                    {{ value1.length == 0 ? 'EMPTY' : value1 }}
                                  </template>
                                  <template
                                    v-if="
                                      field_array_column['type'] !=
                                        'checkbox' && changes[ob] != value1
                                    "
                                  >
                                    <vs-divider class="p-1" />
                                    {{
                                      value1 == null || value1 == ''
                                        ? 'EMPTY'
                                        : value1
                                    }}
                                  </template>
                                </div>
                              </template>
                            </template>
                          </div>
                        </template>
                      </template>

                   
                  </template>
                </td>
              </tr>

              <tr>
                <td v-for="(ob, ind) in Object.keys(changes).slice(20, 25)">
                  <!-- {{ ob }}  -->

                  <template v-if="changes[ob] != null">
                   
                      <template
                        v-for="field_array_column in changes[
                          'campaign_data_options'
                        ]"
                      >
                        <template v-if="field_array_column.column_id == ob">
                          <strong>
                            <p class="p-5">{{ field_array_column.name }}</p>
                          </strong>
                        </template>
                      </template>

                      <template
                        v-for="field_array_column in changes[
                          'campaign_data_options'
                        ]"
                      >
                        <template v-if="field_array_column.column_id == ob">
                          <div
                            v-if="
                              field_array_column['type'] ==
                              'client_contact'
                            "
                          >
                            <div class="width_class">
                              <div class="auto_search_container">
                                <input
                                  class="autocom"
                                  :id="'search_id_' + index_number"
                                  @input="intitudeHandler($event, index_number)"
                                  type="text"
                                  v-model="changes[ob]['full_name']"
                                  @blur="toggle = false"
                                  @focus="toggle = true"
                                />
                                {{ changes[ob]['full_name'] }}
                                <div class="results" v-if="toggle">
                                  <div
                                    v-if="changes['opp_owner_search']"
                                    class="result"
                                    v-for="client_contact in newCampaignClientContacts"
                                  >
                                    <span
                                      @click="
                                        selectResult(index_number, client_contact, ob)
                                      "
                                      @mousedown.prevent
                                    >
                                      {{ client_contact.full_name }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <template
                              v-for="(value1, key1) in changes['old_one']"
                            >
                              <template v-if="key1 == 'client_contact'">
                                <div class="width_class">
                                  <template
                                    v-if="
                                      value1 != '' && value1 != null &&
                                      changes['client_contact'][
                                        'full_name'
                                      ] != ''
                                    "
                                  >
                                    <template
                                      v-if="
                                        changes['client_contact'][
                                          'full_name'
                                        ] != value1['full_name']
                                      "
                                    >
                                      <vs-divider class="p-1" />
                                      {{
                                        value1 != '' && value1 != null
                                          ? value1['full_name']
                                          : 'EMPTY'
                                      }}
                                    </template>
                                  </template>

                                  <template
                                    v-else-if="
                                      changes['client_contact'][
                                        'full_name'
                                      ] != value1
                                    "
                                  >
                                    <vs-divider class="p-1" />
                                    {{ value1 != '' && value1 != null? value1 : 'EMPTY' }}
                                  </template>
                                </div>
                              </template>
                            </template>
                          </div>

                          <div v-else>
                            <div
                              v-if="field_array_column['type'] == 'checkbox'"
                              class="width_class"
                            >
                              <span
                                v-for="(v, key) in JSON.parse(
                                  field_array_column['values']
                                )"
                              >
                                <input
                                  type="checkbox"
                                  v-bind:id="key"
                                  class="ml-4"
                                  :value="v.value"
                                  v-model="changes[ob]"
                                />
                                {{ v.value }}
                                <br />
                              </span>
                            </div>
                            <div
                              v-if="field_array_column['type'] == 'dropdown'"
                            >
                              <v-select
                                class="width_class"
                                v-model="changes[ob]"
                                label="value"
                                :options="
                                  JSON.parse(field_array_column['values'])
                                "
                                name="type"
                              />
                            </div>

                            <div
                              v-if="
                                field_array_column['type'] == 'text' ||
                                field_array_column['type'] == 'opportunity'
                              "
                            >
                              <vs-input
                                class="width_class"
                                name="text"
                                v-model="changes[ob]"
                              />
                            </div>

                            <div
                            v-if="
                              field_array_column['type'] == 'number'
                            "
                          >
                            <vs-input
                            type="number" 
                            class="width_class"
                                name="text"
                              v-model="changes[ob]"
                            />
                          </div>

                            <div
                              v-if="field_array_column['type'] == 'textarea'"
                            >

                            <vue-trumbowyg v-model="changes[ob]" 
                            :config="configs.basic"></vue-trumbowyg>
                              <!-- <vs-textarea
                                class="ql-class"
                                v-model="changes[ob]"
                              /> -->
                            </div>
                            <div v-if="field_array_column['type'] == 'date'">
                              <flat-pickr
                                class="width_class"
                                :config="configDateTimePicker"
                                placeholder="Choose Date"
                                name="continuous_date_end"
                                v-model="changes[ob]"
                              />
                            </div>

                              <div v-if="field_array_column['type'] == 'datetime'">
                              <flat-pickr
                                class="width_class"
                                :config="configDateAndTimePicker"
                                placeholder="Choose Date and Time"
                                name="continuous_date_and_time"
                                v-model="changes[ob]"
                              />
                            </div>

                            <div
                              v-if="field_array_column['type'] == 'choose_one'"
                              class="width_class"
                            >
                              <span
                                v-for="(val, k) in JSON.parse(
                                  field_array_column['values']
                                )"
                              >
                                <input
                                  class="ml-4"
                                  :value="val.value"
                                  type="radio"
                                  v-model="changes[ob]"
                                />
                                {{ val.value }}
                                <br />
                              </span>
                            </div>

                            <template
                              v-for="(value1, key1) in changes['old_one']"
                            >
                              <template v-if="key1 == ob">
                                <div class="width_class">
                                  <template
                                    v-if="
                                      field_array_column['type'] ==
                                        'checkbox' && Array.isArray(value1) &&
                                      changes[ob].length != value1.length
                                    "
                                  >
                                    <vs-divider class="p-1" />
                                    {{ value1.length == 0 ? 'EMPTY' : value1 }}
                                  </template>
                                  <template
                                    v-if="
                                      field_array_column['type'] !=
                                        'checkbox' && changes[ob] != value1
                                    "
                                  >
                                    <vs-divider class="p-1" />
                                    {{
                                      value1 == null || value1 == ''
                                        ? 'EMPTY'
                                        : value1
                                    }}
                                  </template>
                                </div>
                              </template>
                            </template>
                          </div>
                        </template>
                      </template>

                      <!-- <p class='p-5'>{{ changes[ob] }}</p> -->
                  </template>
                </td>
              </tr>
              <tr>
                <td v-for="(ob, ind) in Object.keys(changes).slice(25, 30)">
                  <!-- {{ ob }}  -->

                  <template v-if="changes[ob] != null">
                
                      <template
                        v-for="field_array_column in changes[
                          'campaign_data_options'
                        ]"
                      >
                        <template v-if="field_array_column.column_id == ob">
                          <strong>
                            <p class="p-5">{{ field_array_column.name }}</p>
                          </strong>
                        </template>
                      </template>

                      <template
                        v-for="field_array_column in changes[
                          'campaign_data_options'
                        ]"
                      >
                        <template v-if="field_array_column.column_id == ob">
                          <div
                            v-if="
                              field_array_column['type'] ==
                              'client_contact'
                            "
                          >
                            <div class="width_class">
                              <div class="auto_search_container">
                                <input
                                  class="autocom"
                                  :id="'search_id_' + index_number"
                                  @input="intitudeHandler($event, index_number)"
                                  type="text"
                                  v-model="changes[ob]['full_name']"
                                  @blur="toggle = false"
                                  @focus="toggle = true"
                                />
                                {{ changes[ob]['full_name'] }}
                                <div class="results" v-if="toggle">
                                  <div
                                    v-if="changes['opp_owner_search']"
                                    class="result"
                                    v-for="client_contact in newCampaignClientContacts"
                                  >
                                    <span
                                      @click="
                                        selectResult(index_number, client_contact, ob)
                                      "
                                      @mousedown.prevent
                                    >
                                      {{ client_contact.full_name }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <template
                              v-for="(value1, key1) in changes['old_one']"
                            >
                              <template v-if="key1 == 'client_contact'">
                                <div class="width_class">
                                  <template
                                    v-if="
                                      value1 != '' && value1 != null && 
                                      changes['client_contact'][
                                        'full_name'
                                      ] != ''
                                    "
                                  >
                                    <template
                                      v-if="
                                        changes['client_contact'][
                                          'full_name'
                                        ] != value1['full_name']
                                      "
                                    >
                                      <vs-divider class="p-1" />
                                      {{
                                        value1 != ''  && value1 != null
                                          ? value1['full_name']
                                          : 'EMPTY'
                                      }}
                                    </template>
                                  </template>

                                  <template
                                    v-else-if="
                                      changes['client_contact'][
                                        'full_name'
                                      ] != value1
                                    "
                                  >
                                    <vs-divider class="p-1" />
                                    {{ value1 != '' && value1 != null ? value1 : 'EMPTY' }}
                                  </template>
                                </div>
                              </template>
                            </template>
                          </div>

                          <div v-else>
                            <div
                              v-if="field_array_column['type'] == 'checkbox'"
                              class="width_class"
                            >
                              <span
                                v-for="(v, key) in JSON.parse(
                                  field_array_column['values']
                                )"
                              >
                                <input
                                  type="checkbox"
                                  v-bind:id="key"
                                  class="ml-4"
                                  :value="v.value"
                                  v-model="changes[ob]"
                                />
                                {{ v.value }}
                                <br />
                              </span>
                            </div>
                            <div
                              v-if="field_array_column['type'] == 'dropdown'"
                            >
                              <v-select
                                class="width_class"
                                v-model="changes[ob]"
                                label="value"
                                :options="
                                  JSON.parse(field_array_column['values'])
                                "
                                name="type"
                              />
                            </div>

                            <div
                              v-if="
                                field_array_column['type'] == 'text' ||
                                field_array_column['type'] == 'opportunity'
                              "
                            >
                              <vs-input
                                class="width_class"
                                name="text"
                                v-model="changes[ob]"
                              />
                            </div>

                            <div
                            v-if="
                              field_array_column['type'] == 'number'
                            "
                          >
                            <vs-input
                            type="number" 
                            class="width_class"
                                name="text"
                              v-model="changes[ob]"
                            />
                          </div>

                            <div
                              v-if="field_array_column['type'] == 'textarea'"
                            >

                            <vue-trumbowyg v-model="changes[ob]" 
                            :config="configs.basic"></vue-trumbowyg>
                              <!-- <vs-textarea
                                class="ql-class"
                                v-model="changes[ob]"
                              /> -->
                            </div>
                            <div v-if="field_array_column['type'] == 'date'">
                              <flat-pickr
                                class="width_class"
                                :config="configDateTimePicker"
                                placeholder="Choose Date"
                                name="continuous_date_end"
                                v-model="changes[ob]"
                              />
                            </div>
                              <div v-if="field_array_column['type'] == 'datetime'">
                              <flat-pickr
                                class="width_class"
                                :config="configDateAndTimePicker"
                                placeholder="Choose Date and Time"
                                name="continuous_date_and_time"
                                v-model="changes[ob]"
                              />
                            </div>

                            <div
                              v-if="field_array_column['type'] == 'choose_one'"
                              class="width_class"
                            >
                              <span
                                v-for="(val, k) in JSON.parse(
                                  field_array_column['values']
                                )"
                              >
                                <input
                                  class="ml-4"
                                  :value="val.value"
                                  type="radio"
                                  v-model="changes[ob]"
                                />
                                {{ val.value }}
                                <br />
                              </span>
                            </div>

                            <template
                              v-for="(value1, key1) in changes['old_one']"
                            >
                              <template v-if="key1 == ob">
                                <div class="width_class">
                                  <template
                                    v-if="
                                      field_array_column['type'] ==
                                        'checkbox' && Array.isArray(value1) &&
                                      changes[ob].length != value1.length
                                    "
                                  >
                                    <vs-divider class="p-1" />
                                    {{ value1.length == 0 ? 'EMPTY' : value1 }}
                                  </template>
                                  <template
                                    v-if="
                                      field_array_column['type'] !=
                                        'checkbox' && changes[ob] != value1
                                    "
                                  >
                                    <vs-divider class="p-1" />
                                    {{
                                      value1 == null || value1 == ''
                                        ? 'EMPTY'
                                        : value1
                                    }}
                                  </template>
                                </div>
                              </template>
                            </template>
                          </div>
                        </template>
                      </template>

                      <!-- <p class='p-5'>{{ changes[ob] }}</p> -->
                  </template>
                </td>
              </tr>

              <tr>
                <td v-for="(ob, ind) in Object.keys(changes).slice(30, 35)">
                  <!-- {{ ob }}  -->

                  <template v-if="changes[ob] != null">
              
                      <template
                        v-for="field_array_column in changes[
                          'campaign_data_options'
                        ]"
                      >
                        <template v-if="field_array_column.column_id == ob">
                          <strong>
                            <p class="p-5">{{ field_array_column.name }}</p>
                          </strong>
                        </template>
                      </template>

                      <template
                        v-for="field_array_column in changes[
                          'campaign_data_options'
                        ]"
                      >
                        <template v-if="field_array_column.column_id == ob">
                          <div
                            v-if="
                              field_array_column['type'] ==
                              'client_contact'
                            "
                          >
                            <div class="width_class">
                              <div class="auto_search_container">
                                <input
                                  class="autocom"
                                  :id="'search_id_' + index_number"
                                  @input="intitudeHandler($event, index_number)"
                                  type="text"
                                  v-model="changes[ob]['full_name']"
                                  @blur="toggle = false"
                                  @focus="toggle = true"
                                />
                                {{ changes[ob]['full_name'] }}
                                <div class="results" v-if="toggle">
                                  <div
                                    v-if="changes['opp_owner_search']"
                                    class="result"
                                    v-for="client_contact in newCampaignClientContacts"
                                  >
                                    <span
                                      @click="
                                        selectResult(index_number, client_contact, ob)
                                      "
                                      @mousedown.prevent
                                    >
                                      {{ client_contact.full_name }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <template
                              v-for="(value1, key1) in changes['old_one']"
                            >
                              <template v-if="key1 == 'client_contact'">
                                <div class="width_class">
                                  <template
                                    v-if="
                                      value1 != '' && value1 != null &&
                                      changes['client_contact'][
                                        'full_name'
                                      ] != ''
                                    "
                                  >
                                    <template
                                      v-if="
                                        changes['client_contact'][
                                          'full_name'
                                        ] != value1['full_name']
                                      "
                                    >
                                      <vs-divider class="p-1" />
                                      {{
                                        value1 != '' && value1 != null
                                          ? value1['full_name']
                                          : 'EMPTY'
                                      }}
                                    </template>
                                  </template>

                                  <template
                                    v-else-if="
                                      changes['client_contact'][
                                        'full_name'
                                      ] != value1
                                    "
                                  >
                                    <vs-divider class="p-1" />
                                       {{ value1 != '' && value1 != null ? value1 : 'EMPTY' }}
                                  </template>
                                </div>
                              </template>
                            </template>
                          </div>

                          <div v-else>
                            <div
                              v-if="field_array_column['type'] == 'checkbox'"
                              class="width_class"
                            >
                              <span
                                v-for="(v, key) in JSON.parse(
                                  field_array_column['values']
                                )"
                              >
                                <input
                                  type="checkbox"
                                  v-bind:id="key"
                                  class="ml-4"
                                  :value="v.value"
                                  v-model="changes[ob]"
                                />
                                {{ v.value }}
                                <br />
                              </span>
                            </div>
                            <div
                              v-if="field_array_column['type'] == 'dropdown'"
                            >
                              <v-select
                                class="width_class"
                                v-model="changes[ob]"
                                label="value"
                                :options="
                                  JSON.parse(field_array_column['values'])
                                "
                                name="type"
                              />
                            </div>

                            <div
                              v-if="
                                field_array_column['type'] == 'text' ||
                                field_array_column['type'] == 'opportunity'
                              "
                            >
                              <vs-input
                                class="width_class"
                                name="text"
                                v-model="changes[ob]"
                              />
                            </div>

                            <div
                            v-if="
                              field_array_column['type'] == 'number'
                            "
                          >
                            <vs-input
                            type="number" 
                            class="width_class"
                                name="text"
                              v-model="changes[ob]"
                            />
                          </div>

                            <div
                              v-if="field_array_column['type'] == 'textarea'"
                            >

                            <vue-trumbowyg v-model="changes[ob]" 
                            :config="configs.basic"></vue-trumbowyg>
                              <!-- <vs-textarea
                                class="ql-class"
                                v-model="changes[ob]"
                              /> -->
                            </div>
                            <div v-if="field_array_column['type'] == 'date'">
                              <flat-pickr
                                class="width_class"
                                :config="configDateTimePicker"
                                placeholder="Choose Date"
                                name="continuous_date_end"
                                v-model="changes[ob]"
                              />
                            </div>
                              <div v-if="field_array_column['type'] == 'datetime'">
                              <flat-pickr
                                class="width_class"
                                :config="configDateAndTimePicker"
                                placeholder="Choose Date and Time"
                                name="continuous_date_and_time"
                                v-model="changes[ob]"
                              />
                            </div>

                            <div
                              v-if="field_array_column['type'] == 'choose_one'"
                              class="width_class"
                            >
                              <span
                                v-for="(val, k) in JSON.parse(
                                  field_array_column['values']
                                )"
                              >
                                <input
                                  class="ml-4"
                                  :value="val.value"
                                  type="radio"
                                  v-model="changes[ob]"
                                />
                                {{ val.value }}
                                <br />
                              </span>
                            </div>

                            <template
                              v-for="(value1, key1) in changes['old_one']"
                            >
                              <template v-if="key1 == ob">
                                <div class="width_class">
                                  <template
                                    v-if="
                                      field_array_column['type'] ==
                                        'checkbox' && Array.isArray(value1) &&
                                      changes[ob].length != value1.length
                                    "
                                  >
                                    <vs-divider class="p-1" />
                                    {{ value1.length == 0 ? 'EMPTY' : value1 }}
                                  </template>
                                  <template
                                    v-if="
                                      field_array_column['type'] !=
                                        'checkbox' && changes[ob] != value1
                                    "
                                  >
                                    <vs-divider class="p-1" />
                                    {{
                                      value1 == null || value1 == ''
                                        ? 'EMPTY'
                                        : value1
                                    }}
                                  </template>
                                </div>
                              </template>
                            </template>
                          </div>
                        </template>
                      </template>

                     
                  </template>
                </td>

                <td v-for="(ob, ind) in Object.keys(changes).slice(35, 40)">
                  <!-- {{ ob }}  -->

                  <template v-if="changes[ob] != null">
               
                      <template
                        v-for="field_array_column in changes[
                          'campaign_data_options'
                        ]"
                      >
                        <template v-if="field_array_column.column_id == ob">
                          <strong>
                            <p class="p-5">{{ field_array_column.name }}</p>
                          </strong>
                        </template>
                      </template>

                      <template
                        v-for="field_array_column in changes[
                          'campaign_data_options'
                        ]"
                      >
                        <template v-if="field_array_column.column_id == ob">
                          <div
                            v-if="
                              field_array_column['type'] ==
                              'client_contact'
                            "
                          >
                            <div class="width_class">
                              <div class="auto_search_container">
                                <input
                                  class="autocom"
                                  :id="'search_id_' + index_number"
                                  @input="intitudeHandler($event, index_number)"
                                  type="text"
                                  v-model="changes[ob]['full_name']"
                                  @blur="toggle = false"
                                  @focus="toggle = true"
                                />
                                {{ changes[ob]['full_name'] }}
                                <div class="results" v-if="toggle">
                                  <div
                                    v-if="changes['opp_owner_search']"
                                    class="result"
                                    v-for="client_contact in newCampaignClientContacts"
                                  >
                                    <span
                                      @click="
                                        selectResult(index_number, client_contact, ob)
                                      "
                                      @mousedown.prevent
                                    >
                                      {{ client_contact.full_name }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <template
                              v-for="(value1, key1) in changes['old_one']"
                            >
                              <template v-if="key1 == 'client_contact'">
                                <div class="width_class">
                                  <template
                                    v-if="
                                      value1 != '' && value1 != null &&
                                      changes['client_contact'][
                                        'full_name'
                                      ] != ''
                                    "
                                  >
                                    <template
                                      v-if="
                                        changes['client_contact'][
                                          'full_name'
                                        ] != value1['full_name']
                                      "
                                    >
                                      <vs-divider class="p-1" />
                                      {{
                                        value1 != '' && value1 != null
                                          ? value1['full_name']
                                          : 'EMPTY'
                                      }}
                                    </template>
                                  </template>

                                  <template
                                    v-else-if="
                                      changes['client_contact'][
                                        'full_name'
                                      ] != value1
                                    "
                                  >
                                    <vs-divider class="p-1" />
                                                                        {{ value1 != '' && value1 != null ? value1 : 'EMPTY' }}
                                  </template>
                                </div>
                              </template>
                            </template>
                          </div>

                          <div v-else>
                            <div
                              v-if="field_array_column['type'] == 'checkbox'"
                              class="width_class"
                            >
                              <span
                                v-for="(v, key) in JSON.parse(
                                  field_array_column['values']
                                )"
                              >
                                <input
                                  type="checkbox"
                                  v-bind:id="key"
                                  class="ml-4"
                                  :value="v.value"
                                  v-model="changes[ob]"
                                />
                                {{ v.value }}
                                <br />
                              </span>
                            </div>
                            <div
                              v-if="field_array_column['type'] == 'dropdown'"
                            >
                              <v-select
                                class="width_class"
                                v-model="changes[ob]"
                                label="value"
                                :options="
                                  JSON.parse(field_array_column['values'])
                                "
                                name="type"
                              />
                            </div>

                            <div
                              v-if="
                                field_array_column['type'] == 'text' ||
                                field_array_column['type'] == 'opportunity'
                              "
                            >
                              <vs-input
                                class="width_class"
                                name="text"
                                v-model="changes[ob]"
                              />
                            </div>

                            <div
                            v-if="
                              field_array_column['type'] == 'number'
                            "
                          >
                            <vs-input
                            type="number" 
                            class="width_class"
                                name="text"
                              v-model="changes[ob]"
                            />
                          </div>

                            <div
                              v-if="field_array_column['type'] == 'textarea'"
                            >

                            <vue-trumbowyg v-model="changes[ob]" 
                            :config="configs.basic"></vue-trumbowyg>
                              <!-- <vs-textarea
                                class="ql-class"
                                v-model="changes[ob]"
                              /> -->
                            </div>
                            <div v-if="field_array_column['type'] == 'date'">
                              <flat-pickr
                                class="width_class"
                                :config="configDateTimePicker"
                                placeholder="Choose Date"
                                name="continuous_date_end"
                                v-model="changes[ob]"
                              />
                            </div>
                              <div v-if="field_array_column['type'] == 'datetime'">
                              <flat-pickr
                                class="width_class"
                                :config="configDateAndTimePicker"
                                placeholder="Choose Date and Time"
                                name="continuous_date_and_time"
                                v-model="changes[ob]"
                              />
                            </div>

                            <div
                              v-if="field_array_column['type'] == 'choose_one'"
                              class="width_class"
                            >
                              <span
                                v-for="(val, k) in JSON.parse(
                                  field_array_column['values']
                                )"
                              >
                                <input
                                  class="ml-4"
                                  :value="val.value"
                                  type="radio"
                                  v-model="changes[ob]"
                                />
                                {{ val.value }}
                                <br />
                              </span>
                            </div>

                            <template
                              v-for="(value1, key1) in changes['old_one']"
                            >
                              <template v-if="key1 == ob">
                                <div class="width_class">
                                  <template
                                    v-if="
                                      field_array_column['type'] ==
                                        'checkbox' && Array.isArray(value1) &&
                                      changes[ob].length != value1.length
                                    "
                                  >
                                    <vs-divider class="p-1" />
                                    {{ value1.length == 0 ? 'EMPTY' : value1 }}
                                  </template>
                                  <template
                                    v-if="
                                      field_array_column['type'] !=
                                        'checkbox' && changes[ob] != value1
                                    "
                                  >
                                    <vs-divider class="p-1" />
                                    {{
                                      value1 == null || value1 == ''
                                        ? 'EMPTY'
                                        : value1
                                    }}
                                  </template>
                                </div>
                              </template>
                            </template>
                          </div>
                        </template>
                      </template>

                  </template>
                </td>

                <td v-for="(ob, ind) in Object.keys(changes).slice(40, 45)">
                  <!-- {{ ob }}  -->

                  <template v-if="changes[ob] != null">
                  
                      <template
                        v-for="field_array_column in changes[
                          'campaign_data_options'
                        ]"
                      >
                        <template v-if="field_array_column.column_id == ob">
                          <strong>
                            <p class="p-5">{{ field_array_column.name }}</p>
                          </strong>
                        </template>
                      </template>

                      <template
                        v-for="field_array_column in changes[
                          'campaign_data_options'
                        ]"
                      >
                        <template v-if="field_array_column.column_id == ob">
                          <div
                            v-if="
                              field_array_column['type'] ==
                              'client_contact'
                            "
                          >
                            <div class="width_class">
                              <div class="auto_search_container">
                                <input
                                  class="autocom"
                                  :id="'search_id_' + index_number"
                                  @input="intitudeHandler($event, index_number)"
                                  type="text"
                                  v-model="changes[ob]['full_name']"
                                  @blur="toggle = false"
                                  @focus="toggle = true"
                                />
                                {{ changes[ob]['full_name'] }}
                                <div class="results" v-if="toggle">
                                  <div
                                    v-if="changes['opp_owner_search']"
                                    class="result"
                                    v-for="client_contact in newCampaignClientContacts"
                                  >
                                    <span
                                      @click="
                                        selectResult(index_number, client_contact, ob)
                                      "
                                      @mousedown.prevent
                                    >
                                      {{ client_contact.full_name }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <template
                              v-for="(value1, key1) in changes['old_one']"
                            >
                              <template v-if="key1 == 'client_contact'">
                                <div class="width_class">
                                  <template
                                    v-if="
                                      value1 != '' && value1 != null &&
                                      changes['client_contact'][
                                        'full_name'
                                      ] != ''
                                    "
                                  >
                                    <template
                                      v-if="
                                        changes['client_contact'][
                                          'full_name'
                                        ] != value1['full_name']
                                      "
                                    >
                                      <vs-divider class="p-1" />
                                      {{
                                        value1 != '' && value1 != null
                                          ? value1['full_name']
                                          : 'EMPTY'
                                      }}
                                    </template>
                                  </template>

                                  <template
                                    v-else-if="
                                      changes['client_contact'][
                                        'full_name'
                                      ] != value1
                                    "
                                  >
                                    <vs-divider class="p-1" />
                                                                        {{ value1 != '' && value1 != null ? value1 : 'EMPTY' }}
                                  </template>
                                </div>
                              </template>
                            </template>
                          </div>

                          <div v-else>
                            <div
                              v-if="field_array_column['type'] == 'checkbox'"
                              class="width_class"
                            >
                              <span
                                v-for="(v, key) in JSON.parse(
                                  field_array_column['values']
                                )"
                              >
                                <input
                                  type="checkbox"
                                  v-bind:id="key"
                                  class="ml-4"
                                  :value="v.value"
                                  v-model="changes[ob]"
                                />
                                {{ v.value }}
                                <br />
                              </span>
                            </div>
                            <div
                              v-if="field_array_column['type'] == 'dropdown'"
                            >
                              <v-select
                                class="width_class"
                                v-model="changes[ob]"
                                label="value"
                                :options="
                                  JSON.parse(field_array_column['values'])
                                "
                                name="type"
                              />
                            </div>

                            <div
                              v-if="
                                field_array_column['type'] == 'text' ||
                                field_array_column['type'] == 'opportunity'
                              "
                            >
                              <vs-input
                                class="width_class"
                                name="text"
                                v-model="changes[ob]"
                              />
                            </div>

                            <div
                            v-if="
                              field_array_column['type'] == 'number'
                            "
                          >
                            <vs-input
                            type="number" 
                            class="width_class"
                                name="text"
                              v-model="changes[ob]"
                            />
                          </div>

                            <div
                              v-if="field_array_column['type'] == 'textarea'"
                            >

                            <vue-trumbowyg v-model="changes[ob]" 
                            :config="configs.basic"></vue-trumbowyg>
                              <!-- <vs-textarea
                                class="ql-class"
                                v-model="changes[ob]"
                              /> -->
                            </div>
                            <div v-if="field_array_column['type'] == 'date'">
                              <flat-pickr
                                class="width_class"
                                :config="configDateTimePicker"
                                placeholder="Choose Date"
                                name="continuous_date_end"
                                v-model="changes[ob]"
                              />
                            </div>
                              <div v-if="field_array_column['type'] == 'datetime'">
                              <flat-pickr
                                class="width_class"
                                :config="configDateAndTimePicker"
                                placeholder="Choose Date and Time"
                                name="continuous_date_and_time"
                                v-model="changes[ob]"
                              />
                            </div>

                            <div
                              v-if="field_array_column['type'] == 'choose_one'"
                              class="width_class"
                            >
                              <span
                                v-for="(val, k) in JSON.parse(
                                  field_array_column['values']
                                )"
                              >
                                <input
                                  class="ml-4"
                                  :value="val.value"
                                  type="radio"
                                  v-model="changes[ob]"
                                />
                                {{ val.value }}
                                <br />
                              </span>
                            </div>

                            <template
                              v-for="(value1, key1) in changes['old_one']"
                            >
                              <template v-if="key1 == ob">
                                <div class="width_class">
                                  <template
                                    v-if="
                                      field_array_column['type'] ==
                                        'checkbox' && Array.isArray(value1) &&
                                      changes[ob].length != value1.length
                                    "
                                  >
                                    <vs-divider class="p-1" />
                                    {{ value1.length == 0 ? 'EMPTY' : value1 }}
                                  </template>
                                  <template
                                    v-if="
                                      field_array_column['type'] !=
                                        'checkbox' && changes[ob] != value1
                                    "
                                  >
                                    <vs-divider class="p-1" />
                                    {{
                                      value1 == null || value1 == ''
                                        ? 'EMPTY'
                                        : value1
                                    }}
                                  </template>
                                </div>
                              </template>
                            </template>
                          </div>
                        </template>
                      </template>

                      <!-- <p class='p-5'>{{ changes[ob] }}</p> -->
                  </template>
                </td>

                <td v-for="(ob, ind) in Object.keys(changes).slice(45, 50)">
                  <!-- {{ ob }}  -->

                  <template v-if="changes[ob] != null">
                  
                      <template
                        v-for="field_array_column in changes[
                          'campaign_data_options'
                        ]"
                      >
                        <template v-if="field_array_column.column_id == ob">
                          <strong>
                            <p class="p-5">{{ field_array_column.name }}</p>
                          </strong>
                        </template>
                      </template>

                      <template
                        v-for="field_array_column in changes[
                          'campaign_data_options'
                        ]"
                      >
                        <template v-if="field_array_column.column_id == ob">
                          <div
                            v-if="
                              field_array_column['type'] ==
                              'client_contact'
                            "
                          >
                            <div class="width_class">
                              <div class="auto_search_container">
                                <input
                                  class="autocom"
                                  :id="'search_id_' + index_number"
                                  @input="intitudeHandler($event, index_number)"
                                  type="text"
                                  v-model="changes[ob]['full_name']"
                                  @blur="toggle = false"
                                  @focus="toggle = true"
                                />
                                {{ changes[ob]['full_name'] }}
                                <div class="results" v-if="toggle">
                                  <div
                                    v-if="changes['opp_owner_search']"
                                    class="result"
                                    v-for="client_contact in newCampaignClientContacts"
                                  >
                                    <span
                                      @click="
                                        selectResult(index_number, client_contact, ob)
                                      "
                                      @mousedown.prevent
                                    >
                                      {{ client_contact.full_name }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <template
                              v-for="(value1, key1) in changes['old_one']"
                            >
                              <template v-if="key1 == 'client_contact'">
                                <div class="width_class">
                                  <template
                                    v-if="
                                      value1 != '' && value1 != null &&
                                      changes['client_contact'][
                                        'full_name'
                                      ] != ''
                                    "
                                  >
                                    <template
                                      v-if="
                                        changes['client_contact'][
                                          'full_name'
                                        ] != value1['full_name']
                                      "
                                    >
                                      <vs-divider class="p-1" />
                                      {{
                                        value1 != '' && value1 != null
                                          ? value1['full_name']
                                          : 'EMPTY'
                                      }}
                                    </template>
                                  </template>

                                  <template
                                    v-else-if="
                                      changes['client_contact'][
                                        'full_name'
                                      ] != value1
                                    "
                                  >
                                    <vs-divider class="p-1" />
                                                                        {{ value1 != '' && value1 != null ? value1 : 'EMPTY' }}
                                  </template>
                                </div>
                              </template>
                            </template>
                          </div>

                          <div v-else>
                            <div
                              v-if="field_array_column['type'] == 'checkbox'"
                              class="width_class"
                            >
                              <span
                                v-for="(v, key) in JSON.parse(
                                  field_array_column['values']
                                )"
                              >
                                <input
                                  type="checkbox"
                                  v-bind:id="key"
                                  class="ml-4"
                                  :value="v.value"
                                  v-model="changes[ob]"
                                />
                                {{ v.value }}
                                <br />
                              </span>
                            </div>
                            <div
                              v-if="field_array_column['type'] == 'dropdown'"
                            >
                              <v-select
                                class="width_class"
                                v-model="changes[ob]"
                                label="value"
                                :options="
                                  JSON.parse(field_array_column['values'])
                                "
                                name="type"
                              />
                            </div>

                            <div
                              v-if="
                                field_array_column['type'] == 'text' ||
                                field_array_column['type'] == 'opportunity'
                              "
                            >
                              <vs-input
                                class="width_class"
                                name="text"
                                v-model="changes[ob]"
                              />
                            </div>

                            <div
                            v-if="
                              field_array_column['type'] == 'number'
                            "
                          >
                            <vs-input
                            type="number" 
                            class="width_class"
                                name="text"
                              v-model="changes[ob]"
                            />
                          </div>

                            <div
                              v-if="field_array_column['type'] == 'textarea'"
                            >

                            <vue-trumbowyg v-model="changes[ob]" 
                            :config="configs.basic"></vue-trumbowyg>
                              <!-- <vs-textarea
                                class="ql-class"
                                v-model="changes[ob]"
                              /> -->
                            </div>
                            <div v-if="field_array_column['type'] == 'date'">
                              <flat-pickr
                                class="width_class"
                                :config="configDateTimePicker"
                                placeholder="Choose Date"
                                name="continuous_date_end"
                                v-model="changes[ob]"
                              />
                            </div>
                              <div v-if="field_array_column['type'] == 'datetime'">
                              <flat-pickr
                                class="width_class"
                                :config="configDateAndTimePicker"
                                placeholder="Choose Date and Time"
                                name="continuous_date_and_time"
                                v-model="changes[ob]"
                              />
                            </div>

                            <div
                              v-if="field_array_column['type'] == 'choose_one'"
                              class="width_class"
                            >
                              <span
                                v-for="(val, k) in JSON.parse(
                                  field_array_column['values']
                                )"
                              >
                                <input
                                  class="ml-4"
                                  :value="val.value"
                                  type="radio"
                                  v-model="changes[ob]"
                                />
                                {{ val.value }}
                                <br />
                              </span>
                            </div>

                            <template
                              v-for="(value1, key1) in changes['old_one']"
                            >
                              <template v-if="key1 == ob">
                                <div class="width_class">
                                  <template
                                    v-if="
                                      field_array_column['type'] ==
                                        'checkbox' && Array.isArray(value1) &&
                                      changes[ob].length != value1.length
                                    "
                                  >
                                    <vs-divider class="p-1" />
                                    {{ value1.length == 0 ? 'EMPTY' : value1 }}
                                  </template>
                                  <template
                                    v-if="
                                      field_array_column['type'] !=
                                        'checkbox' && changes[ob] != value1
                                    "
                                  >
                                    <vs-divider class="p-1" />
                                    {{
                                      value1 == null || value1 == ''
                                        ? 'EMPTY'
                                        : value1
                                    }}
                                  </template>
                                </div>
                              </template>
                            </template>
                          </div>
                        </template>
                      </template>

                    
                  </template>
                </td>
              </tr>
            </tbody>
          </table>
        </template>
      </template>
    </vx-card>
  </div>
</template>

<script>
import moduleAccountsManagement from '@/store/accounts-management/moduleAccountsManagement.js'
import defineAbilitiesFor from '@/config/abilities'
import moduleCampaignManagement from '@/store/campaign-management/moduleCampaignManagement.js'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import moduleElomarkUserManagement from '@/store/elomark-user-management/moduleElomarkUserManagement.js'
import moduleGradeManagement from '@/store/grade-management/moduleGradeManagement.js'

import VueTrumbowyg  from 'vue-trumbowyg';
import 'jquery-resizable-dom/dist/jquery-resizable.js';
import 'jquery-resizable-dom/dist/jquery-resizableTableColumns.js';

import 'trumbowyg/dist/trumbowyg.min.js';
import 'trumbowyg/dist/ui/trumbowyg.min.css';
import 'trumbowyg/dist/plugins/colors/ui/trumbowyg.colors.min.css';
import 'trumbowyg/dist/plugins/table/trumbowyg.table.min.js';
import 'trumbowyg/dist/plugins/table/ui/trumbowyg.table.min.css';
import 'trumbowyg/dist/plugins/fontsize/trumbowyg.fontsize.min.js';
import 'trumbowyg/dist/plugins/upload/trumbowyg.upload.min.js';
import 'trumbowyg/dist/plugins/colors/trumbowyg.colors.min.js'
import 'trumbowyg/dist/plugins/colors/ui/trumbowyg.colors.min.css'
import 'trumbowyg/dist/plugins/pasteimage/trumbowyg.pasteimage.min.js'
import 'trumbowyg/dist/plugins/preformatted/trumbowyg.preformatted.min.js'
import 'trumbowyg/dist/plugins/lineheight/trumbowyg.lineheight.min.js'
import 'trumbowyg/dist/plugins/indent/trumbowyg.indent.min.js'
import 'trumbowyg/dist/plugins/resizimg/trumbowyg.resizimg.js'

export default {
  data: () => ({
    configs: {
          basic: {
            autogrow: true,
            removeformatPasted: true,
                btns: [
                    ['strong', 'em'],
                    ['superscript', 'subscript'],
                    ['fontsize'],
                    ['foreColor', 'backColor'],
                    ['link'],
                    ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
                    ['horizontalRule'],
                    ['removeformat'],
                    ['fullscreen']
                ],
                plugins: {
                    table: {
                        columns: 10,
                        rows: 10,
                    
                    },
                    resizimg: {
            minSize: 64,
            step: 16,
        }

                    }
                        }
      },
    all_account_status: [],
    client_contact_value: null,
    search: '',
    toggle: false,
    campaign_client_contacts: [],
    newCampaignClientContacts: [],
    phoneTypes: [],
    grade_options: [],
    checkedFields: [],
    user_id: null,
    abilities: null,
    selected_campaign: null,
    campaignDescription: [],
    opportunity_review_changes: null,
    account_contact_details: [],
    selected_account_fields: [],
    selected_contact_fields: [],
    selected_account_core_fields: [],
    selected_contact_core_fields: [],
    selected_opportunity_fields_with_details: [],
    selected_account_fields_with_details: [],
   configDateAndTimePicker: {
      enableTime: true,
      dateFormat: "Y-m-d H:i:s",
      enableSeconds : true
    },
    configDateTimePicker: {
      enableTime: false,
      dateFormat: 'Y-m-d'
    }
  }),
  components: {
    'v-select': vSelect,
    flatPickr,
    quillEditor,
    VueTrumbowyg
  },
  watch: {
    search (val) {
      let self = this
      self.newCampaignClientContacts = []

      console.log('CAMP CLI', self.campaign_client_contacts)

      self.campaign_client_contacts.forEach(element => {
        if (element.full_name.includes(val) && val != '') {
          self.newCampaignClientContacts.push(element)
        }
      })

      const key = 'user_id'

      self.newCampaignClientContacts = [
        ...new Map(
          self.newCampaignClientContacts.map(item => [item[key], item])
        ).values()
      ]

      console.log(self.newCampaignClientContacts)
    }
  },
  methods: {
    intitudeHandler (val, id) {
      // val = val.data

      val = document.getElementById('search_id_' + id).value

      let self = this

      self.opportunity_review_changes[id]['opp_owner_search'] = true

      self.newCampaignClientContacts = []

      self.campaign_client_contacts.forEach(element => {
        if (element.full_name.includes(val) && val != '') {
          self.newCampaignClientContacts.push(element)
        }
      })

      const key = 'user_id'

      self.newCampaignClientContacts = [
        ...new Map(
          self.newCampaignClientContacts.map(item => [item[key], item])
        ).values()
      ]
    },
    selectResult (index, client_contact , key) {
      let self = this
      self.search = client_contact.full_name

      let dataObj = {}
      dataObj.full_name = client_contact.full_name
      dataObj.id = client_contact.uuid

      for (const property in self.opportunity_review_changes) {
        self.opportunity_review_changes[index][key] = dataObj
      }

      self.opportunity_review_changes[index]['opp_owner_search'] = false
    },
    goToReviewDataChangesDetail (account_id) {
      this.$router.push({
        path:
          '/quality_control/review_data/account_detail/' +
          account_id +
          '/' +
          this.$route.params.campaignId +
          '/' +
          this.$route.params.campaignName
      })
    },
    fetchCampaignAssociatedClientContact () {
      let self = this
      this.$store
        .dispatch(
          'elomarkUsersManagement/fetchCampaignAssociatedClientContact',
          this.$route.params.campaignId
        )
        .then(res => {
          self.campaign_client_contacts =
            moduleElomarkUserManagement.state.campaign_associated_client_contact
          self.campaign_client_contacts.map(function (ele) {
            ele.full_name = ele.first_name + ' ' + ele.surname
          })
        })
        .catch(err => {
          console.log(err)
        })
    },

    reviewerOpportunityAccepted (changes) {
      let self = this
      let data = {}
      data.reviewer_id = self.user_id
      data.changes = changes
      self.$vs.loading()

      this.$store
        .dispatch('campaignsManagement/reviewerOpportunityAccepted', data)
        .then(res => {
          if (res.data.status == 'success') {
            this.$vs.notify({
              color: 'success',
              title: 'Data Changes',
              text: res.data.message
            })
            self.$vs.loading.close()
            this.$router.go(0)

            // this.getCampaignOpportunityReviewChanges()
          }
        })
        .catch(err => {
          console.error(err)
        })
    },
    reviewerOpportunityRejected (changes) {
      let self = this
      let data = {}
      data.uuid = changes['uuid']
      data.reviewer_id = self.user_id
      data.changes = changes
      // data.key = key
      // if (data.key == 'phone_no' || data.key == 'url' || data.key == 'url' || data.key == 'contact_ddi' || data.key == 'contact_email' || data.key == 'contact_mobile' || data.key == 'contact_social_media') {

      //   if (val[key] == 'EMPTY' || val[key] == '') {
      //     data.changes['field'] = null;
      //   } else {
      //     if (!Array.isArray(val[key])) {
      //       data.val = val[key].split(",");
      //     } else {
      //       data.val = val[key];
      //     }
      //   }
      // } else {
      //   if (val[key] == 'EMPTY') {
      //     data.val = null;
      //   } else {
      //     data.val = val[key];
      //   }

      // }
      self.$vs.loading()
      this.$store
        .dispatch('campaignsManagement/reviewerOpportunityRejected', data)
        .then(res => {
          if (res.data.status == 'success') {
            this.$vs.notify({
              color: 'success',
              title: 'Data Changes',
              text: res.data.message
            })
            self.$vs.loading.close()
            this.$router.go(0)
            // this.getCampaignOpportunityReviewChanges()
          }
        })
        .catch(err => {
          console.error(err)
        })
    },
    goToReviewQualityControlPage (data) {
      this.$router.push({
        path:
          '/quality_control/account_data/' +
          data.uuid +
          '/' +
          btoa(data.campaign_name)
      })
    },
    goToQualityControlAccounts (data) {
      this.$router.push({
        path:
          '/quality_control/account_data/' +
          data.uuid +
          '/' +
          btoa(data.campaign_name)
      })
      // console.log(data)
      // this.$router.replace("/sales-developer-dashboard/view/" + this.selected_campaign.campaign_id + '/' + btoa(this.selected_campaign.campaign_name));
      //  alert("got to")
    },
    goToQualityControlContacts (data) {
      this.$router.push({
        path:
          '/quality_control/contact_data/' +
          data.uuid +
          '/' +
          btoa(data.campaign_name)
      })

      // this.$router.replace("/sales-developer-dashboard/view/" + this.selected_campaign.campaign_id + '/' + btoa(this.selected_campaign.campaign_name));
      //  alert("got to")
    },
    getCampaignDescription () {
      const campaignId = this.$route.params.campaignId
      this.$store
        .dispatch('campaignsManagement/fetchCampaign', campaignId)
        .then(res => {
          this.campaignDescription = res.data
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.campaignDescription = true
            return
          }
          console.error(err)
        })
    },
    getCampaignOpportunityReviewChanges () {
      let self = this
      let data = {}
      data.campaign_id = this.$route.params.campaignId
      data.campaign_name = atob(this.$route.params.campaignName)
      this.$store
        .dispatch(
          'campaignsManagement/getCampaignOpportunityReviewChanges',
          data
        )
        .then(res => {
          this.opportunity_review_changes = res.data

          this.opportunity_review_changes.forEach(function (el) {
            el['opp_owner_search'] = false

            Object.keys(el).forEach(key => {

              console.log('key', key)

                  

              if (el[key] == null || el[key] == '' || el[key] == '[]') {
                if (
                  key != 'reviewer_accepted' &&
                  key != 'reviewer_id' &&
                  key != 'updated'
                ) {
                  el[key] = ''
                }
              }

              let campaign_data_options = el['campaign_data_options']

              campaign_data_options.forEach(function (cdo) {
                
                
                
                
                if (cdo.type == 'client_contact' && cdo.column_id == key) {





if (el[key] == null || el[key] == '' || el[key] == '[]') {


  let data = {}
data.full_name = ''
data.id = ''
el[key] = data

}else{
  el[key] = JSON.parse(el[key])
}




}
                
                
                
                if (
                  cdo.type == 'checkbox' &&
                  cdo.column_id == key
                ) {
                  if (el[key] == null || el[key] == '' || el[key] == '[]') {
                    el[key] = []
                  } else {
                    el[key] = JSON.parse(el[key])
                  }
                }



             






              })
            })
          })

          console.log('opp review', this.opportunity_review_changes)
        })
        .catch(err => {
          console.error(err)
        })
    },
    firstLast (arr) {
      if (arr.length < 2) return arr
      return [arr[0], arr[arr.length - 1]]
    },
    goBack: function () {
      this.$router.go(-1)
    }
  },
  beforeMount () {},
  mounted () {
    this.fetchCampaignAssociatedClientContact()
    this.getCampaignDescription()
    this.getCampaignOpportunityReviewChanges()
  },
  created () {
    var self = this
    defineAbilitiesFor().then(function (data) {
      self.abilities = data
    })
    let userInfo = JSON.parse(localStorage.getItem('userInfo'))
    self.user_id = userInfo['uid']
    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        'campaignsManagement',
        moduleCampaignManagement
      )
      moduleCampaignManagement.isRegistered = true
    }

    if (!moduleAccountsManagement.isRegistered) {
      this.$store.registerModule('accountsManagement', moduleAccountsManagement)
      moduleAccountsManagement.isRegistered = true
    }

    if (!moduleElomarkUserManagement.isRegistered) {
      this.$store.registerModule(
        'elomarkUsersManagement',
        moduleElomarkUserManagement
      )
      moduleElomarkUserManagement.isRegistered = true
    }

    if (!moduleGradeManagement.isRegistered) {
      this.$store.registerModule('GradesManagement', moduleGradeManagement)
      moduleGradeManagement.isRegistered = true
    }
  }
}
</script>
<style scoped>
.social_media_radio {
  width: auto;
}

.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 15px 15px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  width: 325px !important;
}

.searchbox {
  margin-left: 5px;
  width: 600px;
}

.filter {
  width: 300px;
}

.pointer {
  cursor: pointer;
}

.item.expanded {
  background-color: white !important;
  color: black !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  background: none !important;
  box-shadow: none !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  color: #626262 !important;
  -webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
  box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
}

.vs-input-class{
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.2);
  font-size: 1rem;
  height: 38px;
  padding-left: 10px;
  padding-right: -10px;
  border-radius: 4px;
  background: transparent;
  transition: all .2s ease;


}

.accept-button {
  cursor: pointer;
}

.address_th {
  padding: 30px;
}

.address_td {
  padding: 30px;
  font-weight: 500;
}

.width_class {
  /* max-width: 400px; */
  width: 300px;
}

.imput_field {
  width: 500px;
}

.hyperlink_class {
  cursor: pointer;
}

.dropdown_class {
  border: 1px solid transparent;
  margin: 4px 0 0 0;
  padding: 0 7px;
  background: none;
  box-shadow: none;
  width: 500px;
  background: none;
  border: 1px solid rgba(60, 60, 60, 0.26);
  border-radius: 4px;
  position: relative;
  font-family: inherit;
  height: 35px;
}

.ql-class {
  width: auto;
}
</style>

<style lang="stylus">
.inputx
  margin-left 20px
  margin-top 10px



.con-expand-Fields
  .con-btns-Fields
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-Fieldsx
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>
